/**
 * @generated SignedSource<<f2bee2451ac76838a0c72e5cce4ba471>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "request"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "request"
      }
    ],
    "concreteType": "Impulse",
    "kind": "LinkedField",
    "name": "updateImpulseEmail",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "version",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ImpulseUser",
        "kind": "LinkedField",
        "name": "impulseClient",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ImpulseImplEmailMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ImpulseImplEmailMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3eadd844b31b03dae1e2fd032b271d6d",
    "id": null,
    "metadata": {},
    "name": "ImpulseImplEmailMutation",
    "operationKind": "mutation",
    "text": "mutation ImpulseImplEmailMutation(\n  $request: UpdateImpulseEmailRequestInput\n) {\n  updateImpulseEmail(request: $request) {\n    id\n    version\n    impulseClient {\n      email\n    }\n  }\n}\n"
  }
};
})();

node.hash = "b317d1a40947e3f3ae46cdc44d93311f";

module.exports = node;
